// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.75927 10.8021L0 17.5614L1.41229 18.9737C3.13356 20.6949 5.24765 21.784 7.46598 22.2408L6.75927 10.8021Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.48466 22.4813C12.38 22.5804 15.3044 21.6371 17.647 19.6515L8.76082 10.7654L9.48466 22.4813Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0611 18.2373C21.0464 15.8948 21.9896 12.9706 21.8905 10.0755L10.1751 9.35126L19.0611 18.2373Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.65 8.05681C21.1932 5.83847 20.1041 3.72438 18.3829 2.00311L16.9706 0.59082L10.2117 7.3497L21.65 8.05681Z"}}]};

const LemonSliceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lemon-slice-filled',
    ref,
    icon: element,
  },
));

LemonSliceFilledIcon.displayName = 'LemonSliceFilledIcon';

export default LemonSliceFilledIcon;
